export default "__VITE_ASSET__fc5ba0fa__"